import { render, staticRenderFns } from "./ProfileEditView.vue?vue&type=template&id=b8dc1686&"
import script from "./ProfileEditView.vue?vue&type=script&lang=js&"
export * from "./ProfileEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports